<template>
  <div class="goods">
    <van-nav-bar title="爱车直卖" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>

    <div>
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">车主基本信息</div>
    </div>
    <div>
      <van-cell-group style="padding-left: .432rem;border-bottom: .405rem solid #E9E9E9">
        <van-field v-model="city" disabled label="卖车城市" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="cellphone" type="text" label="手机号码" placeholder="请填写手机号码" />
        <van-field v-model="name" type="text" label="您的称呼" placeholder="请填写您的称呼（2-6字）" />
        <van-field v-model="address" type="text" label="看车地点" placeholder="请填写看车地点" />
      </van-cell-group>
    </div>

    <div>
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">车辆基本信息</div>
    </div>
    <div style="margin-left: .432rem;font-size: .378rem;color: #333;margin-top: .459rem;border-bottom: 0.02667rem solid #E9E9E9;">
      <div>上传车辆照片或视频</div>
      <van-uploader v-model="fileList" multiple style="margin: .574rem 0;"/>
    </div>
    <div>
      <van-cell-group style="padding-left: .432rem;border-bottom: .405rem solid #E9E9E9">
        <van-field v-model="brand" disabled label="车辆品牌" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="color" disabled label="车辆颜色" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="time" disabled label="上牌时间" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="mileage" type="text" label="行驶里程" placeholder="请填写行驶里程"><template v-slot:right-icon>万公里</template></van-field>
        <van-field v-model="price" type="text" label="车辆售价" placeholder="请填写车辆售价"><template v-slot:right-icon>万</template></van-field>
        <van-field v-model="mortgage" disabled label="有无抵押" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="LicensePlate" disabled label="牌照信息" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="ChangeNumber" disabled label="过户次数" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="AddConfiguration" disabled label="加装配置" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="options" disabled label="车源信息" right-icon="arrow" placeholder="请选择" @click="show=true;"/>
        <van-field v-model="vehicles" type="text" label="车况描述" placeholder="请填写车况描述"/>
        <van-field v-model="ChassisNumber" type="text" label="车架号" placeholder="请填写车架号"/>
      </van-cell-group>
    </div>

    <div>
      <div class="flex-start" style="height:1.28rem;font-size:0.459rem;color: #333;margin-left: .351rem;border-bottom: 1px solid #E9E9E9;font-weight: bold;">真实车源验证</div>
    </div>
    <div style="margin-left: .432rem;font-size: .378rem;color: #333;margin-top: .459rem;border-bottom: 0.02667rem solid #E9E9E9;">
      <div>上传车辆手续图片</div>
      <div style="margin-right: .432rem;font-size: .324rem;color: #999;padding: .486rem;background: #F6FAFF;margin-top: .486rem;line-height: .66rem;">
        <div>1.实拍上传车牌号和行驶证，通过审核后可点亮<van-tag color="#65A0F9" plain>行驶证已验</van-tag><van-tag color="#65A0F9" plain>车牌已验</van-tag>标签</div>
        <div>2.上传全部4张图片，通过审核后可点亮<van-tag color="#05D37E" plain>手续齐全</van-tag>标签</div>
      </div>

      <ul class="flex-start validation" style="padding-right: .432rem;margin: .432rem 0">
        <li style="width: 2rem;text-align: center;margin-right: .324rem" v-for="item,index in hfileList" v-if="index !=3">
          <van-uploader v-bind:v-model="item.fileList" multiple :max-count="1" icon="photo"/><div style="font-size: .324rem;color: #999;height: 1rem;line-height: .5rem;margin-top: .3rem;">{{item.name}}</div>
        </li>
        <li style="width: 2rem;text-align: center;" v-else>
          <van-uploader v-bind:v-model="item.fileList" multiple :max-count="1" icon="photo"/><div style="font-size: .324rem;color: #999;height: 1rem;line-height: .5rem;margin-top: .3rem;">{{item.name}}</div>
        </li>
      </ul>
    </div>
    <div class="flex-start" style="border-bottom: 0.405rem solid rgb(233, 233, 233);height: 1.08rem;color: #e9081a;font-size: .324rem;padding: 0 .324rem;">承诺：证件仅用于审核不做展示或其他用途</div>

    <van-checkbox v-model="checked" style="width: 90%;font-size: .324rem;color: #999;margin: .378rem auto">我已阅读<span style="color: #e9081a">《隐私保护条款》《平台发布规范》</span></van-checkbox>
    <div class="flex-center" style="width: 100%;margin-bottom: .378rem;">
      <div class="flex-center" style="background: #e9081a;color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toPublish">发布车辆信息</div>
    </div>

    <!--选择地址弹框-->
    <van-popup v-model="show" position="bottom" >
      <van-picker show-toolbar :columns="columns" @cancel="show=false;" @confirm="onConfirm"/>
    </van-popup>
  </div>
</template>

<script>
    import {
        NavBar,
        Field,
        Picker,
        Popup,
        Icon,
        CellGroup,
        Uploader,
        Tag,
        button,
        Checkbox,
        CheckboxGroup
    } from 'vant';

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Field.name]: Field,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [CellGroup.name]: CellGroup,
            [Uploader.name]: Uploader,
            [Tag.name]: Tag,
            [button.name]: button,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },

        data() {
            return {
                city:"",
                cellphone:"",
                name:"",
                address:"",
                show:false,
                columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
                fileList: [],
                fileList1: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                hfileList:[
                    {name:"车牌号",fileList:"fileList1"},
                    {name:"行驶证主页",fileList:"fileList2"},
                    {name:"登记证机动车信息栏",fileList:"fileList3"},
                    {name:"购车发票",fileList:"fileList4"}
                ],
                brand:"",
                color:"",
                time:"",
                mileage:"",
                price:"",
                mortgage:"",
                LicensePlate:"",
                ChangeNumber:"",
                AddConfiguration:"",
                options:"",
                vehicles:"",
                ChassisNumber:"",
                checked: true
            };
        },

        methods: {
            onConfirm(value) {
                this.city = value;
                this.show = false;
            },
            toPublish() {
                this.$router.push('/SellCars/Succeed');
            },
            onClickLeft() {
                this.$router.push('/SellCars');
            }
        }
    };
</script>

<style lang="less">
  .goods {
    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #fff;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
    font-size: .486rem;
    color: #333;
  }
  .van-nav-bar .van-icon{
    font-size: .486rem;
    color: #333;
  }

  .van-cell{
    padding: 0;
    padding-right: .432rem;
    height: 1.28rem;
    line-height: 1.28rem;
    font-size: 0.378rem;
    color: #333;
    border-bottom: 1px solid #E9E9E9;
  }
  .van-uploader__preview{
    margin: 0 .351rem .351rem 0;
  }
  .van-uploader__preview-image{
    width: 2rem;
    height: 2rem;
    border-radius: .2rem;
    overflow: hidden;
  }
  .van-tag{
    padding: .05rem .1rem;
    font-size: .27rem;
    margin: 0 .1rem;
  }
  .van-uploader__upload-icon{
    color: #e9081a;
  }
  .van-uploader__upload{
    width: 2rem;
    height: 2rem;
    margin: 0;
    border-radius: .27rem;
    overflow: hidden;
  }

  .validation li .van-uploader__upload-icon{
    width: .68rem;
    height: .68rem;
    text-align: center;
    line-height: .68rem;
    background-image: url("../../image/demo1.png");
    background-size: 100%;
  }
  .validation li:nth-child(2) .van-uploader__upload-icon{
    background-image: url("../../image/demo2.png");
  }
  .validation li:nth-child(3) .van-uploader__upload-icon{
    background-image: url("../../image/demo3.png");
  }
  .validation li:nth-child(4) .van-uploader__upload-icon{
    background-image: url("../../image/demo4.png");
  }
  .validation .van-icon-plus:before{
    content: "";
  }
</style>
